// @flow
import * as constants from '../constants/configConstants';

type LoadConfigAction = {|
    type: typeof constants.LOAD_CONFIG,
    data: $ReadOnlyArray<any>
|};

type SetConfigAction = {|
    type: typeof constants.SET_CONFIG,
    data: any
|};

type UnsetConfigAction = {|
    type: typeof constants.UNSET_CONFIG,
    data: any
|};

type PreviewMapSourceAction = {|
    type: typeof constants.PREVIEW_MAP_SOURCE,
    data: string | null
|};

export type ConfigAction =
    | LoadConfigAction
    | SetConfigAction
    | UnsetConfigAction
    | PreviewMapSourceAction;

const configActions = {
    loadConfig: (data: $ReadOnlyArray<any>): LoadConfigAction => ({
        type: constants.LOAD_CONFIG,
        data: data
    }),
    setConfig: (data: any): SetConfigAction => ({
        type: constants.SET_CONFIG,
        data: data
    }),

    unsetConfig: (data: any): UnsetConfigAction => ({
        type: constants.UNSET_CONFIG,
        data: data
    }),

    previewMapSource: (sourceId: string | null): PreviewMapSourceAction => ({
        type: constants.PREVIEW_MAP_SOURCE,
        data: sourceId
    })
};

export default configActions;